export const SET_AVAILABLE_PLANS = 'SET_AVAILABLE_PLANS';
export const SET_SELECTED_PLAN = 'SET_SELECTED_PLAN';
export const SET_USER_LOADING = 'SET_USER_LOADING';
export const LOG_IN = 'LOG_IN';
export const LOG_OUT = 'LOG_OUT';
export const UPDATE_USER = 'UPDATE_USER';
export const UPDATE_USER_ERROR = 'UPDATE_USER_ERROR';

export const REGISTER = 'REGISTER';
export const CONFIRM_EMAIL = 'CONFIRM_EMAIL';
export const RESEND_EMAIL = 'RESEND_EMAIL';
export const UPDATE_PASS = 'UPDATE_PASS';
export const CLEAR_UPDATE_PASS = 'CLEAR_UPDATE_PASS';

export const GET_CARDS = 'GET_CARDS';
export const ADD_CARD = 'ADD_CARD';
export const UPDATE_CARD = 'UPDATE_CARD';
export const UPDATE_DEFAULT_CARD = 'UPDATE_DEFAULT_CARD';
export const DELETE_CARD = 'DELETE_CARD';
export const SET_CARD_ERROR = 'SET_CARD_ERROR';

export const GET_TRANSACTIONS = 'GET_TRANSACTIONS';

export const GET_CHECKOUT_SESSION = 'GET_CHECKOUT_SESSION';
export const GET_CUSTOMER_SUBSCRIPTION = 'GET_CUSTOMER_SUBSCRIPTION';
export const SUBSCRIPTION = 'SUBSCRIPTION';
export const GET_PRORATION_AMOUNT = 'GET_PRORATION_AMOUNT';
export const SUBSCRIPTION_ERROR = 'SUBSCRIPTION_ERROR';
export const CLEAR_SUBSCRIPTION_ERROR = 'CLEAR_SUBSCRIPTION_ERROR';

export const CREATE_BOOKMARK = 'CREATE_BOOKMARK';
export const DELETE_BOOKMARK = 'DELETE_BOOKMARK';
export const DELETE_BOOKMARKS = 'DELETE_BOOKMARKS';
export const GET_BOOKMARKS = 'GET_BOOKMARKS';
export const CLEAR_BOOKMARKS = 'CLEAR_BOOKMARKS';
export const SET_BOOKMARK_LOADING = 'SET_BOOKMARK_LOADING';

export const FORGOT_PASS = 'FORGOT_PASS';
export const RESET_PASS = 'RESET_PASS';

export const CREATE_COMMENT = 'CREATE_COMMENT';

// export const GET_CLIENT_PRODUCT_BY_ID = 'GET_CLIENT_PRODUCT_BY_ID';

export const INVITE_USER = 'INVITE_USER';
export const INVITE_USER_ERROR = 'INVITE_USER_ERROR';

export const GET_USERS_BY_CLIENT_ID = 'GET_USERS_BY_CLIENT_ID';

export const UPDATE_USER_PLAN = 'UPDATE_USER_PLAN';
export const UPDATE_USER_PLAN_ERROR = 'UPDATE_USER_PLAN_ERROR';

export const DELETE_USER_CLIENT = 'DELETE_USER_CLIENT';
export const SET_USER_CLIENT_ERROR = 'SET_USER_ERROR_CLIENT';

export const UPDATE_CLIENT_ROLE = 'UPDATE_CLIENT_ROLE';

export const REINVITE_USER = 'REINVITE_USER';
export const REINVITE_USER_ERROR = 'REINVITE_USER_ERROR';

export const SEND_ENQUIRY = 'SEND_ENQUIRY';

export const SUBSCRIPTION_UPDATE = 'SUBSCRIPTION_UPDATE';

export const GET_PAYMENT_METHOD = 'GET_PAYMENT_METHOD';

export const CREATE_CLIENT_SUBSCRIPTION = 'CREATE_CLIENT_SUBSCRIPTION';
export const UPDATE_CLIENT_SUBSCRIPTION = 'UPDATE_CLIENT_SUBSCRIPTION';

export const GET_USER_PLANS = 'GET_USER_PLANS';
export const GET_USER_USAGE = 'GET_USER_USAGE';
export const UPDATE_USER_USAGE = 'UPDATE_USER_USAGE';
